import React from "react";

function Experience() {
  return <div id="experience" className="experience">
      <div className="d-flex justify-content-center my-5"> 
      <h1> experience </h1>
      </div>
      <div className="container experience-wrapper"> 
      <div className="timeline-block timeline-block-left">
          {/* <div className="marker"> </div> */}
              {/* <div className="timeline-content">
                  <h3> 1989 </h3>
                  <p>Born  </p>
              </div> */}
              
          </div>
      <div className="timeline-block timeline-block-right">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> 1999 </h3>
                  <p> After recieving my first gaming console (Gameboy) my interest and love of technology began </p>
              </div>
          </div>
          {/* */}
          <div className="timeline-block timeline-block-left">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> 2005</h3>
                  <p> &#9749; Had my first ever coffee and never turned back &#9749;  </p>
              </div>
          </div>
          {/* */}
          <div className="timeline-block timeline-block-right">
          <div className="marker"> </div>
              <div className="timeline-content">
              <h3> 2009-2011 	
&#127891; </h3><em className="text-muted"> Education </em> 
                  <p>  Completed a Bachelors in Psycology at University of South Australia</p>
              </div>
          </div>
           {/* */}
          <div className="timeline-block timeline-block-left">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> 2012-2013 	
&#127891; </h3> <em className="text-muted"> Education </em> 
                  <p> Completed a Masters Degree in Commerce Marketing at the University of Adelaide</p>
              </div>
          </div>
           {/* */}
           <div className="timeline-block timeline-block-right">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> 2015-Current </h3>
                  <em className="text-muted"> Skills Experience  </em>
                  <p> Opened my first business 'Mississippi Moon' in the Adelaide CBD. </p>
                  <p> Developed skills in customer service, team leadership, team managment, communication (staff and stakeholders) project managment, problem solving  </p>
              </div>
          </div>
                     {/* */}
           <div className="timeline-block timeline-block-left">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> September-2021  </h3> <em className="text-muted"> Code Education  </em>
                  <p> Started studying Full Stack Web Development through Adelaide Univertisty</p>
                  <p> Coffee intake increased...</p>
              </div>
          </div>
           {/* */}
           <div className="timeline-block timeline-block-right">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> October-2021</h3>
                  <em className="text-muted"> Code Education  </em>
                  <p> Completed first major project for Coding Bootcamp "Instant Crypto". Project had to feature two server-side API's, use client-side storage to store persistent data, be responsive and accept and respond to user input  </p>
              </div>
          </div>
                    {/* */}
          <div className="timeline-block timeline-block-left">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> December-2021  </h3> <em className="text-muted"> Code Education  </em>
                  <p> Completed second major project for Coding Bootcamp "Career Headstart" Project used Node.js and Express.js to create RESTful API, Handlebars.js as a template engine,  MySQL and the sequelize ORM for the database, have both GET and Post routes  
                      for retrieving and adding new data, protect API keys and sensitive information with enviromental variable and include authentication  
                  </p>
              </div>
          </div>
           <div className="timeline-block timeline-block-right">
          <div className="marker"> </div>
              <div className="timeline-content">
                  <h3> Feburary-2022</h3>
                  <em className="text-muted"> Code Education  </em>
                  <p> Completed and gained certificate in Full Stack Web Development from Adelaide University, averaging A+ grade for all projects and homeworks </p>
              </div>
          </div>
      </div>
  </div>;
}

export default Experience;
